import "./css/ress.css";
import "./App.css";
import "./site/styles/site.scss";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import { usePageTracking } from "./analytics/usePageTracking";
import AiAdoptionConsult from "./components/AiAdoptionConsult";
import AiAdoptionDiagnosis from "./components/AiAdoptionDiagnosis";
import AiAdoptionDocument from "./components/AiAdoptionDocument";
import AiAdoptionDownload from "./components/AiAdoptionDownload";
import AiAdoptionWhitepaper from "./components/AiAdoptionWhitepaper";
import ScrollOnHashMount from "./components/ScrollOnHashMount";
import Seo from "./components/Seo";
import WhitepaperAiCaseStudies from "./components/WhitepaperAiCaseStudies";
import { resolveRouteMeta } from "./seo/siteMeta";
import SiteFooter from "./site/SiteFooter";
import SiteHeader from "./site/SiteHeader";
import CaseDetailPage from "./site/pages/CaseDetailPage";
import CasesPage from "./site/pages/CasesPage";
import CompanyPage from "./site/pages/CompanyPage";
import ContactPage from "./site/pages/ContactPage";
import HomePage from "./site/pages/HomePage";
import NewsDetailPage from "./site/pages/NewsDetailPage";
import NewsPage from "./site/pages/NewsPage";
import NotFoundPage from "./site/pages/NotFoundPage";
import PrivacyPage from "./site/pages/PrivacyPage";
import ServiceAiPage from "./site/pages/ServiceAiPage";
import ServiceBlockchainPage from "./site/pages/ServiceBlockchainPage";
import ServicesPage from "./site/pages/ServicesPage";
import ThanksPage from "./site/pages/ThanksPage";

// 独自nav/footerを持つルート。グローバルのHeader/Footerを出さない。
//
// フォーム4本は自前の最小ヘッダー（ロゴのみ）とフッター（社名のみ）を持つ。
// コンバージョン導線なので、実績・お知らせ・問い合わせのような
// 外に逃がすリンクを置かない作りになっている。
// ここに入れ忘れるとグローバルのHeader/Footerが重なる。
const BARE_ROUTES = [
  "/diagnosis",
  "/document",
  "/download",
  "/whitepaper",
  "/consult",
];

function AppShell() {
  const { pathname } = useLocation();
  const bare = BARE_ROUTES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );

  // 静的ルートのメタはここでまとめて適用する。
  // 詳細ページ（/news/:slug・/cases/:slug）は ROUTE_META に無いため null になり、
  // 各コンポーネントが描画する <Seo /> が単独で効く（タイトルの二重指定を避ける）。
  const routeMeta = resolveRouteMeta(pathname);

  usePageTracking();

  return (
    <div className="App">
      {routeMeta && (
        <Seo
          title={routeMeta.title}
          description={routeMeta.description}
          path={pathname}
        />
      )}
      {!bare && <SiteHeader />}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/ai-integration" element={<ServiceAiPage />} />
        <Route
          path="/services/blockchain"
          element={<ServiceBlockchainPage />}
        />
        <Route path="/cases" element={<CasesPage />} />
        <Route path="/cases/:slug" element={<CaseDetailPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:slug" element={<NewsDetailPage />} />
        <Route path="/company" element={<CompanyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contact/thanks" element={<ThanksPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        {/* LP（/service/ai-adoption）は廃止し、入口は /media/ に一本化した。
            旧URLは public/.htaccess の301で送っている。 */}
        <Route path="/diagnosis" element={<AiAdoptionDiagnosis />} />
        <Route path="/document" element={<AiAdoptionDocument />} />
        <Route path="/download" element={<AiAdoptionDownload />} />
        <Route path="/whitepaper" element={<AiAdoptionWhitepaper />} />
        <Route
          path="/whitepaper/ai-case-studies"
          element={<WhitepaperAiCaseStudies />}
        />
        <Route path="/consult" element={<AiAdoptionConsult />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {!bare && <SiteFooter />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollOnHashMount />
      <AppShell />
    </Router>
  );
}

export default App;
